import moment from 'moment'

import infoIcon from 'app/assets/icons/summary_icons/info.svg'
import { ContainerHeader } from 'app/components/display/text/standard_text/standard-headings/component'
import { TOTAL_INCOME_EXTRA_TEXT_KEY } from 'app/constants/application-settings.constants'
import 'app/match/apply/application_summary_before_submit/components/preference_container/style.scss'
import { isMobile } from 'app/shared_components/helpers'
import { applicationText } from 'app/sm/apply/apply_helper'
import {
  defaultRentScheduleOptions,
  parseDataUtil,
  urlTo,
} from 'app/sm/helpers'
import {
  ApplicationDetailsLongTextComponent,
  ApplicationDetailsNumbersComponent,
  ApplicationDetailsNumbersComponentRowStyle,
} from 'app/sm/renter_applications/renter_application_detailed/components/new_applicant-details'
import { isStateVIC } from 'app/utils/address/helpers'
import { resolveFormCapabilities } from 'app/utils/applications/formCapabilities'
import * as vehicleHelpers from 'app/utils/applications/vehicles'
import { RENTER_SUMMARY } from 'app/utils/text/helpers'

const PreferenceComponent = ({
  componentClassName = '',
  application = {},
  isSummaryEditable = true,
  onEditClick,
  totalEmployedWeeklyNetIncome = 0,
  totalWeeklyNetIncomeEditedByManager = 0,
  propertyOffer = {},
  property = {},
  enableNote = false,
  onNewNoteUpdated,
  newNotesContent,
  onNoteIconClicked,
  onNewNoteAdded,
  onNoteCrossClicked,
  interpreteNoteResult = {},
  enableNotesButton,
  displayedApplicant,
  section,
  toggleRequestInfoModal = undefined,
  toggleEditRenterApplication = undefined,
  isManagerAdded = false,
  isManagerSummary = false,
  isLeaseUpdated = false,
  teamSettingInfo = {},
  excludeRequestVehicleRegistration,
  isQLDForm22 = false,
  formCapabilities,
}) => {
  let {
    weeklyRent = 0,
    term = '',
    leaseStartDate = '',
    aboutMe = '',
    requests = '',
    applicants = [],
    pets = 0,
    adults = 0,
    children = [],
    applicationType,
    rentScheduleType = 0,
    requestCarSpace = false,
    managerAddedRent = 0,
    managerAddedLeaseTerm = 0,
    managerAddedLeaseStartDate = '',
    managerAddedPets = 0,
    allVehicles,
    guidID,
    people = 0,
  } = application
  const totalPets = managerAddedPets > 0 ? managerAddedPets : pets
  const originalValuesLeaseRequestedValues = {
    weeklyRent,
    leaseStartDate,
    term,
  }
  weeklyRent =
    isManagerSummary && managerAddedRent > 0 ? managerAddedRent : weeklyRent
  leaseStartDate =
    isManagerSummary && managerAddedLeaseStartDate !== ''
      ? managerAddedLeaseStartDate
      : leaseStartDate
  term =
    isManagerSummary && managerAddedLeaseTerm > 0
      ? String(managerAddedLeaseTerm)
      : term
  const {
    weeklyRent: offeredWeeklyRent = 0,
    availableFrom: advertLeaseStartDate,
  } = propertyOffer
  const { address: propertyAddress = {}, state: propertyState = '' } = property
  const resolvedPropertyState = propertyAddress.state || propertyState
  const formattedStartDate = moment(leaseStartDate).format('DD MMM YYYY')
  const originalFormattedStartDate = moment(
    originalValuesLeaseRequestedValues.leaseStartDate,
  ).format('DD MMM YYYY')
  const applicantNumber = applicants.length
  const rentDifference = weeklyRent - offeredWeeklyRent
  let rentDifferenceText = 0
  if (rentDifference !== 0) {
    rentDifferenceText =
      rentDifference > 0
        ? `+ $${rentDifference}`
        : `- $${Math.abs(rentDifference)}`
  }
  const leaseStartDateVariance = moment(leaseStartDate).diff(
    moment(advertLeaseStartDate),
    'days',
  )
  const leaseStartDateVarianceText =
    leaseStartDateVariance === 0
      ? ''
      : `${Math.abs(leaseStartDateVariance)} days ${
          leaseStartDateVariance > 0 ? 'after' : 'before'
        } `
  const showRentDifference = applicationType !== 2
  const rentScheduleOption =
    defaultRentScheduleOptions.find(
      (option) => option.index === rentScheduleType,
    ) || {}
  const rentScheduleText = rentScheduleOption.value || 'Not provided'
  const requestCarSpaceText = requestCarSpace ? 'Yes' : 'No'

  const { application: applicationSettings = {} } = teamSettingInfo

  const parsedTeamApplicationSettingInfo =
    parseDataUtil.convertObjValueFromStringToBoolean(applicationSettings)

  let { disable_children_option: disableChildrenOption = false } =
    parsedTeamApplicationSettingInfo

  const resolvedFormCapabilities = resolveFormCapabilities(formCapabilities)
  const showAbout = !isQLDForm22 && resolvedFormCapabilities.hasAbout
  const showRequest = !isQLDForm22 && resolvedFormCapabilities.hasRequest
  const showRent = resolvedFormCapabilities.showAdvertisedRentInShare
  const showRentSchedule = resolvedFormCapabilities.showRentScheduleInShare
  // Show Total Income only if income value is greater than 0
  const showTotalIncomeInLeaseRequested = totalEmployedWeeklyNetIncome > 0
  const showTotalIncomeInLease = totalWeeklyNetIncomeEditedByManager > 0

  // show children if application already submitted with children
  if (children?.length > 0) {
    disableChildrenOption = false
  }

  const showChildren =
    !disableChildrenOption && resolvedFormCapabilities.hasChildren
  const showPets = resolvedFormCapabilities.hasPetDetails
  const derivedOccupantsCount = adults + (showChildren ? children.length : 0)
  const occupantsCount = people > 0 ? people : derivedOccupantsCount
  const showVicOccupantsOnlySummary =
    isManagerSummary && isStateVIC(resolvedPropertyState) && occupantsCount > 0
  const occupantsTitle = showVicOccupantsOnlySummary
    ? 'Occupants'
    : `Occupants (${occupantsCount})`
  const occupantsText = [
    `Adults ${adults}`,
    showChildren ? `Children (under 18) ${children.length}` : '',
    showPets ? `Pets ${totalPets}` : '',
  ]
    .filter((o) => o.length > 0)
    .join(', ')

  const totalVehicles = allVehicles && allVehicles.length
  const totalVehiclesText = vehicleHelpers.formTotalVehiclesText(
    allVehicles,
    excludeRequestVehicleRegistration,
  )
  const totalIncomeExtraText = `/w ${applicationText(
    isQLDForm22,
    TOTAL_INCOME_EXTRA_TEXT_KEY,
  )}`

  return (
    <>
      {isLeaseUpdated && (
        <>
          <p className="standard-subheading mr20 ml20">Lease</p>
          <div className="application-details-numbers-box preference-lease-numbers-box display-flex pdf-width-80 mr20 ml20">
            {showRent && (
              <ApplicationDetailsNumbersComponent
                title="Rent"
                text={`$${weeklyRent}`}
                componentClassName="width50p align-items-start flex-basis-25p"
                extraText="/w"
                titleClassName="preference-lease-label"
                textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
                titleTextClassName="pdf-font-size-10"
                showHookedText={showRentDifference && rentDifference !== 0}
                hookedText={rentDifferenceText}
              />
            )}
            <ApplicationDetailsNumbersComponent
              title="Term"
              text={term}
              componentClassName="width50p align-items-start flex-basis-25p"
              extraText="months"
              titleClassName="preference-lease-label"
              textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
              titleTextClassName="pdf-font-size-10"
            />
            <ApplicationDetailsNumbersComponent
              title="Lease Start / Move in Date"
              text={formattedStartDate}
              componentClassName="width50p align-items-start flex-basis-25p"
              titleClassName=""
              textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
              titleTextClassName="pdf-font-size-10"
            />
            {showTotalIncomeInLease && (
              <div
                className="align-items-start flex-basis-25p"
                style={{ minWidth: 0, maxWidth: '25%', overflow: 'hidden' }}
                data-total-income-cell
              >
                <ApplicationDetailsNumbersComponent
                  title="Total Income (Assessed)"
                  text={`$${
                    Number.isInteger(totalWeeklyNetIncomeEditedByManager)
                      ? totalWeeklyNetIncomeEditedByManager
                      : totalWeeklyNetIncomeEditedByManager
                          .toFixed(2)
                          .replace(/\.00$/, '')
                          .replace(/(\.[1-9]*)0$/, '$1')
                  }`}
                  extraText={totalIncomeExtraText}
                  componentClassName="width100 align-items-start"
                  titleClassName="preference-lease-label"
                  textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
                  titleTextClassName="pdf-font-size-10"
                />
              </div>
            )}
          </div>
        </>
      )}
      <div className={`container-component pdf-bbs ${componentClassName}`}>
        <div className="application-details-info-container">
          <ContainerHeader
            icon={infoIcon}
            text="Lease requested"
            isEditable={isSummaryEditable}
            onEditClick={() =>
              onEditClick(
                `${urlTo('application', {
                  applicationId: application.guidID,
                  from: RENTER_SUMMARY,
                })}`,
              )
            }
            enableNote={enableNote}
            onNewNoteUpdated={onNewNoteUpdated}
            newNotesContent={newNotesContent}
            onNoteIconClicked={onNoteIconClicked}
            onNewNoteAdded={onNewNoteAdded}
            onNoteCrossClicked={onNoteCrossClicked}
            interpreteNoteResult={interpreteNoteResult}
            enableNotesButton={enableNotesButton}
            displayedApplicant={displayedApplicant}
            section={section}
            toggleRequestInfoModal={toggleRequestInfoModal}
            toggleEditRenterApplication={toggleEditRenterApplication}
            isManagerAdded={isManagerAdded}
            targetGUID={guidID}
          />
          <div className="application-details-numbers-box preference-lease-numbers-box display-flex pdf-width-80">
            {showRent && (
              <ApplicationDetailsNumbersComponent
                title="Rent"
                text={`$${originalValuesLeaseRequestedValues.weeklyRent}`}
                componentClassName="width50p align-items-start flex-basis-20p"
                extraText="/w"
                titleClassName="preference-lease-label"
                textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
                titleTextClassName="pdf-font-size-10"
                showHookedText={showRentDifference && rentDifference !== 0}
                hookedText={rentDifferenceText}
                componentMinWidth={isMobile() ? 'min-width-75' : ''}
              />
            )}
            <ApplicationDetailsNumbersComponent
              title="Term"
              text={originalValuesLeaseRequestedValues.term}
              componentClassName="width50p align-items-start flex-basis-20p"
              extraText="months"
              titleClassName="preference-lease-label"
              textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
              titleTextClassName="pdf-font-size-10"
              componentMinWidth={isMobile() ? 'min-width-75' : ''}
            />
            <ApplicationDetailsNumbersComponent
              title="Lease Start / Move in Date"
              text={originalFormattedStartDate}
              componentClassName="width50p align-items-start flex-basis-20p"
              titleClassName=""
              textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
              titleTextClassName="pdf-font-size-10"
              showHookedText={
                showRentDifference && leaseStartDateVariance !== 0
              }
              hookedText={leaseStartDateVarianceText}
            />
            {showTotalIncomeInLeaseRequested && (
              <div
                className="align-items-start flex-basis-40p"
                style={{ minWidth: 0, maxWidth: '40%', overflow: 'hidden' }}
                data-total-income-cell
              >
                <ApplicationDetailsNumbersComponent
                  title="Total Income (Submitted)"
                  text={`$${
                    Number.isInteger(totalEmployedWeeklyNetIncome)
                      ? totalEmployedWeeklyNetIncome
                      : totalEmployedWeeklyNetIncome
                          .toFixed(2)
                          .replace(/\.00$/, '')
                          .replace(/(\.[1-9]*)0$/, '$1')
                  }`}
                  extraText={totalIncomeExtraText}
                  componentClassName="width100 align-items-start"
                  titleClassName="preference-lease-label"
                  textClassName="preference-content pdf-font-size-10 pdf-margin-neg-10"
                  titleTextClassName="pdf-font-size-10"
                />
              </div>
            )}
          </div>
          <div className="pdf-display-flex pdf-width-80">
            <ApplicationDetailsNumbersComponentRowStyle
              title="Total Applicants"
              text={applicantNumber}
              componentClassName="width50p align-items-start flex-basis-25p"
              textClassName="preference-content pdf-font-size-10"
              titleTextClassName="pdf-font-size-10"
            />
            {showRentSchedule && (
              <ApplicationDetailsNumbersComponentRowStyle
                title="Rent schedule"
                text={rentScheduleText}
                componentClassName="width50p align-items-start flex-basis-25p"
                textClassName="preference-content pdf-font-size-10"
                titleTextClassName="pdf-font-size-10"
              />
            )}
            {parsedTeamApplicationSettingInfo.request_car_space && (
              <>
                <ApplicationDetailsNumbersComponentRowStyle
                  title="Request a Car Space"
                  text={requestCarSpaceText}
                  componentClassName="width50p align-items-start flex-basis-25p"
                  textClassName="preference-content pdf-font-size-10"
                  titleTextClassName="pdf-font-size-10"
                />
                <ApplicationDetailsNumbersComponentRowStyle
                  title={`Vehicles (${totalVehicles})`}
                  text={totalVehiclesText}
                  componentClassName="width50p align-items-start flex-basis-25p"
                  textClassName="preference-content pdf-font-size-10"
                  titleTextClassName="pdf-font-size-10"
                />
              </>
            )}
            <ApplicationDetailsNumbersComponentRowStyle
              title={occupantsTitle}
              text={
                showVicOccupantsOnlySummary
                  ? String(occupantsCount)
                  : occupantsText
              }
              componentClassName="align-items-start flex-basis-25p"
              textClassName="preference-content pdf-font-size-10"
              titleTextClassName="pdf-font-size-10"
            />
          </div>
          {(showAbout || showRequest) && (
            <div className="application-detials-request-container display-flex p0 flex-direction-column pdf-display-flex pdf-flex-direction-row">
              {showAbout && (
                <ApplicationDetailsLongTextComponent
                  title="About"
                  text={aboutMe}
                  componentClassName="pl0"
                  titleClassName="preference-lease-label pdf-font-size-10"
                  contentClassName="preference-content"
                />
              )}
              {showRequest && (
                <ApplicationDetailsLongTextComponent
                  title="Request"
                  text={requests}
                  titleClassName="preference-lease-label pdf-font-size-10"
                  contentClassName="preference-content"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default PreferenceComponent
